import types from './types'

const openOutbound = (params = {}) => {
  const { channel } = params

  return {
    type: types.OPEN_OUTBOUND,
    payload: { channel }
  }
}

const closeOutbound = ({ outboundIndex }) => ({
  type: types.CLOSE_OUTBOUND,
  payload: { outboundIndex }
})

const toggleMinimizeOutbound = ({ outboundIndex }) => ({
  type: types.TOGGLE_MINIMIZE_OUTBOUND,
  payload: { outboundIndex }
})

const toggleMaximizeOutbound = ({ outboundIndex }) => ({
  type: types.TOGGLE_MAXIMIZE_OUTBOUND,
  payload: { outboundIndex }
})

const setCurrentDataOutbound = ({ draftId, outboundIndex, outboundCurrentData }) => ({
  type: types.SET_CURRENT_DATA_OUTBOUND,
  payload: { draftId, outboundIndex, outboundCurrentData }
})

export {
  openOutbound,
  closeOutbound,
  toggleMinimizeOutbound,
  toggleMaximizeOutbound,
  setCurrentDataOutbound
}
